import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BookingComponent } from './booking.component';
import { BookingAirComponent } from './components/booking-air.component';
import { BookingHeaderComponent } from './components/booking-header/booking-header.component';
import { BookingHotelComponent } from './components/booking-hotel.component';
import { DatePipeModule } from 'libraries/date/date.module';
import { PermissionModule } from 'libraries/permission/permission.module';
import { DateRangeComponent } from './components/date-range.component';
import { LoaderModule } from 'libraries/component/loader/loader.module';
import { BookingStatusModule } from 'libraries/component/booking/booking-status/booking-status.module';
import { PricePipesModule } from 'libraries/pipes/price/price-pipes.module';
import { PricePipeModule } from 'libraries/pipes/price/price-pipe.module';
import { BookingServiceModule } from 'libraries/service/booking/bookingService.module';
import { HostAliasPipeModule } from "libraries/pipes/host-alias/host-alias-pipe.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { BookingVehicleRentalComponent } from "./components/booking-vehicle-rental.component";
import { MatTableModule } from "@angular/material/table";
import { BookingSectorsModule } from "../../../../libraries/component/booking-sectors/booking-sectors.module";

@NgModule({
    imports: [
        BookingServiceModule,
        BookingStatusModule,
        CommonModule,
        DatePipeModule,
        FontAwesomeModule,
        HostAliasPipeModule,
        LoaderModule,
        PermissionModule,
        PricePipeModule,
        PricePipesModule,
        RouterModule,
        MatTableModule,
        BookingSectorsModule
    ],
    exports: [
        BookingComponent,
    ],
    declarations: [
        BookingComponent,
        BookingHeaderComponent,
        BookingAirComponent,
        BookingHotelComponent,
        DateRangeComponent,
        BookingVehicleRentalComponent,
    ],
})
export class BookingModule { }
